import { WizardStepTitle } from "app/modules/shared/wizard/WizardStepTitle";
import { useDispatch, useSelector } from "react-redux";
import { ServiceChargeInvoicingSteps } from "../../ServiceChargeInvoiceWizardSteps";
import {
  selectServiceChargeInvoice,
  setCurrentStep,
  setServiceChargeInvoiceModel,
} from "../../ServiceChargeInvoicingSlice";
import { useMemo, useState } from "react";
import { WizardStepperFooter } from "app/modules/shared/wizard/WizardStepFooter";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight } from "@fortawesome/pro-solid-svg-icons";
import {
  setDevelopmentCharges,
  setRunPreListCalculation,
} from "../DevelopmentChargesPreList/DevelopmentChargesPreListSlice";
import translations from "utils/translationUtility";

const GraceDays: React.FC = () => {
  const dispatch = useDispatch();

  const serviceChargeInvoice = useSelector(selectServiceChargeInvoice);
  const [defaultGraceDays, setDefaultGraceDays] = useState<number>(
    serviceChargeInvoice.graceDays! < 14 ? 14 : serviceChargeInvoice.graceDays!
  );

  const disableContinue = useMemo(() => {
    return defaultGraceDays >= 14 && defaultGraceDays < 366;
  }, [defaultGraceDays]);

  function goToPreviousStep() {
    updateServiceChargeInvoiceModel();
    dispatch(setCurrentStep(ServiceChargeInvoicingSteps.DevelopmentsOrPropertyManagers));
  }

  function goToNextStep() {
    updateServiceChargeInvoiceModel();
    dispatch(setDevelopmentCharges([]));
    dispatch(setRunPreListCalculation(true));
    dispatch(setCurrentStep(ServiceChargeInvoicingSteps.DevelopmentChargesPreList));
  }

  function updateServiceChargeInvoiceModel() {
    dispatch(
      setServiceChargeInvoiceModel({
        ...serviceChargeInvoice,
        graceDays: defaultGraceDays,
      })
    );
  }

  return (
    <>
      <WizardStepTitle
        stepNumber={ServiceChargeInvoicingSteps.GraceDays}
        title="Select Minimum Grace Days"
        subtitle={
          <>
            <p>
              Please select the minimum number of grace days before {translations.client.toLocaleLowerCase()} payments
              are due.
            </p>
            <p>Please be aware that all freeholder charges have a minimum of 30 grace days.</p>
          </>
        }
      ></WizardStepTitle>
      <div className="d-flex flex-column align-items-center">
        <div className="d-flex">
          <div className="d-flex">
            <label htmlFor="graceDaysInput" className="pe-1 form-label required">
              Minimum grace days
            </label>
          </div>
          <input
            data-test-id="grace-days-step__number-input"
            className="form-control form-control-solid"
            id="graceDaysInput"
            type="number"
            step={1}
            min={14}
            max={365}
            defaultValue={defaultGraceDays}
            onChange={(e) => setDefaultGraceDays(parseInt(e.target.value!))}
          ></input>
        </div>
        {!disableContinue && (
          <div className="fv-plugins-message-container">
            <div className="fv-help-block">
              <p>Grace days must be between 14 days and 365 days</p>
            </div>
          </div>
        )}
      </div>
      <WizardStepperFooter>
        <div className="d-flex justify-content-between">
          <div>
            <button
              data-test-id="grace-days-step__go-back-button"
              className="btn btn-danger btn-sm"
              type="button"
              onClick={() => goToPreviousStep()}
            >
              <FontAwesomeIcon icon={faArrowLeft} />
              <span className="ms-1">Go back</span>
            </button>
          </div>
          <div>
            <button
              data-test-id="grace-days-step__continue-button"
              className="btn btn-success btn-sm"
              type="button"
              onClick={() => goToNextStep()}
              disabled={!disableContinue}
            >
              <span className="me-1">Continue</span>
              <FontAwesomeIcon icon={faArrowRight} />
            </button>
          </div>
        </div>
      </WizardStepperFooter>
    </>
  );
};

export default GraceDays;
